<template>
	<div class="d-flex flex-column h-100">
		<!-- Google tag (gtag.js) --> 
		<Header></Header>
		<router-view />
		<Footer></Footer>
	</div>

</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
export default {
	components: {
		Header,
		Footer,
	},
	methods: {
		isMobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true
			} else {
				return false
			}
		}
	},
}
</script>
<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

nav a.router-link-exact-active {
	color: #42b983;
}

@import url('https://fonts.googleapis.com/css?family=Kanit');
/* @import url('http://fonts.googleapis.com/css?family=Kanit'); */

html,
body {
	font-family: 'Kanit', sans-serif;
}

#app {
	font-family: 'Kanit', sans-serif;
}

html,
body {
	height: 100%;
}

#app {
	display: flex;
	flex-direction: column;
	height: 100%;
}

a:link {
	text-decoration: none;
}

/* visited link */
a:visited {
	text-decoration: none;
}

/* mouse over link */
a:hover {
	text-decoration: none;
}

/* selected link */
a:active {
	text-decoration: none;
}

@media (max-width: 390px) {
	.m_w_100_p {
		width: 100%;
	}
}

.c_main {
	color: rgb(102, 145, 136);
}

.bc_main {
	border-color: rgb(102, 145, 136);
}

.bg_main {
	background-color: rgb(102, 145, 136);
}

.c_secondary {
	color: #f9b6ad;
}

.box-form {
	border-radius: 25px;
	background: white;
	box-shadow: #f9b6ad 0px 5px 15px;
}

.c_wait {
	color: #999999a2;
}

.bg-pink {
	background-color: #eec0ea;
}

@media (max-width: 767px) {
	.box-form {
		max-width: 715px;
	}
}

@media (max-width: 575px) {
	.btn-download {
		width: 100%;
	}
}

@media (max-width: 390px) {
	.btn-download {
		width: 100%;
	}

	.h1,
	h1 {
		font-size: calc(1.12rem + 1.5vw);
	}
}

.hr_main {
	height: 6px;
	border-width: 0;
	color: rgb(102, 145, 136);
	background-color: rgb(102, 145, 136)
}

tbody {
	cursor: pointer;
}

.cusor-pointer {
	cursor: pointer;
}
</style>


